import { render, staticRenderFns } from "./Avisos.vue?vue&type=template&id=d7656502&scoped=true"
import script from "./Avisos.vue?vue&type=script&lang=js"
export * from "./Avisos.vue?vue&type=script&lang=js"
import style0 from "./Avisos.vue?vue&type=style&index=0&id=d7656502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7656502",
  null
  
)

export default component.exports